<template>

    <!-- <div class=""> -->
        <div class="grid">
            <div class="col">
                <div >
                    <label class="font-medium">Department Orders:</label>
                    <Dropdown v-model="selectedOrder" :options="orders" optionLabel="poNo" optionValue="id" class="w-full" placeholder="-- Select Order --" :showClear="true" @change="filterItems"/>
                </div>
            </div>
            
            <div v-if="selectedOrder" class="col mt-2">
                <div class="grid">
                    <div @click.stop class="col-4">
                        <label class="col-fixed" style="width:100px">Single Location</label>
                        <RadioButton class="" v-model="locationDelivery" value=0 @change="checkSingleLocation"/>
                        
                    </div>
                    <div class="col-8">
                        <div class="grid">
                            <div class=" col-5" v-if="locationDelivery==0">
                                <span class="text-sm ">Search location:</span>
                                
                                <InputText v-model="queryLocation" class="w-full mr-1" placeholder="Type a location..." ></InputText>
                            </div>
                            <div class=" col-5" v-if="locationDelivery==0">
                                <span class="text-sm ">Delivery Locations:</span>
                                <Dropdown  class="w-full"  v-model="singleDeliveryLocation" editable :options="filteredLocations" optionLabel="name" optionValue="id" placeholder="Select a location"  @change="findLocation" appendTo="body"/>
                            </div>
                            <div class=" col-2">
                                <label ></label>
                                <Button v-if="locationDelivery==0" class="mt-2" icon="pi pi-save" size="small" raised @click="handleSaveSingleLocation" v-tooltip.top="'Save Location'" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div @click.stop class="col-6 ml-2">
                        Multi Location
                        <RadioButton class="mx-2" v-model="locationDelivery" value=1 @change="checkSingleLocation"/>
                    </div>
                    <div class="col-6">

                    </div>
                </div>
            </div>
        </div>

        <div class="grid">
            <div class="col">
                <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
            </div>
        </div>
        
        <div v-if="selectedOrder" class="flex justify-content-end flex-wrap mb-3">
            <div v-if="locationDelivery!=1" class="flex align-items-center justify-content-center ">
                <label class="font-semibold">
                    Selected Location: 
                </label>
                <label class="font-italic ml-1">
                    {{ (selectedLocation && locationDelivery==0 ?  selectedLocation.name : "NA") }}
                </label>
            </div>
        </div>
           
    <!-- </div> -->

    <DataTable :value="itemsWithoutLocation" stripedRows showGridlines  paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" scrollable :scrollHeight="selectedOrder ? `50vh` : `55vh`" scrollDirection="both"  :loading="loading1" v-model:filters="filters" size="small" ref="itemsPendingLocation" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" >

        <Column header="Sl No" >
            <template #body="slotProps">
                {{ slotProps.index + 1 }}
            </template>
        </Column>
        <Column field="name" header="Item" style="min-width: 13rem">
            <template #body="slotProps">
                {{ slotProps.data.name }}
            </template>
        </Column>
        <Column field="deptPo" header="PO No" >
            <template #body="slotProps">
                {{ slotProps.data.deptPo }}
            </template>
        </Column>
        <Column field="deptPoDate" header="PO Date" style="min-width: 7rem">
            <template #body="slotProps">
                {{ slotProps.data.deptPoDate }}
            </template>
        </Column>
        <Column field="packing" header="Packing"  >
            <template #body="slotProps">
                {{ slotProps.data.packing }}
            </template>
        </Column>
        <Column field="quantity" header="Quantity"  >
            <template #body="slotProps">
                {{ formatNumber(slotProps.data.quantity) }}
            </template>
        </Column>
        <Column field="rate" header="Rate"  >
            <template #body="slotProps">
                {{ formatCurrency(slotProps.data.rate) }}
            </template>
        </Column>
        <Column field="sub_total" header="Sub Total"  >
            <template #body="slotProps">
                {{ formatCurrency(slotProps.data.sub_total) }}
            </template>
        </Column>
        <Column field="category.label" header="Category"  >
            <template #body="slotProps">
                {{ slotProps.data.category.label }}
            </template>
        </Column>
        <Column v-if="locationDelivery==1" header="Location">
             <template #body="slotProps">
                <Button label="Add" size="small" raised severity="help" @click="showMultiLocationDialog(slotProps.data)"></Button>
             </template>
        </Column>
            
    </DataTable>

    <Dialog :visible="locationDialog" modal :closable="false"  >

        <div class="field">
            <ItemLocation :itemDetails="poItem" :dbLocations="deliveryLocations" @bind-location="bindData"/>
        </div>

        <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="flex align-items-center justify-content-center my-1 mx-1" size="small" label="Save" severity="success" raised @click="handleSaveMultiLocation"></Button>
            
            <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="secondary" text raised @click="locationDialog=false"></Button>
        </div>
        </template>
    </Dialog>
</template>

<script>
import { deptOrdersItems, orderNosList } from '@/services/api/v2/apis';
import { createDeptPOItemLocation, getDeliveryLocations } from '@/services/apiService';
import Button from 'primevue/button';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import ItemLocation from '../itemLocation.vue';
import { FilterMatchMode } from 'primevue/api'
import InputText from 'primevue/inputtext';

export default {
    name:'SetLocationComponent',
    // props:{
        //     data:Array,
        //     loading:Boolean,
        // },
        components:{
            DataTable,
            Column,
        Dropdown,
        RadioButton,
        Button,
        Dialog,
        ItemLocation,
        InputText,
    },
    data(){
        return{
            orders:[],
            selectedOrder:null,
            orgData:[],
            itemsWithoutLocation:[],
            loading1:false,
            locationDelivery:null,
            deliveryLocations:[],
            queryLocation:null,
            singleDeliveryLocation:null,
            selectedLocation:null,
            locationDialog:false,
            uniqueOrderNos:[],
            poId:null,
            poItem:null,
            deliveryLocation:[],
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.IN },
                // deptPo: { value: null, matchMode: FilterMatchMode.IN },          
                rate: { value: null, matchMode: FilterMatchMode.IN },
                'category.label': { value: null, matchMode: FilterMatchMode.IN },
            },
        }
    },
    mounted(){
        this.fetchOrderNos();
        this.getLocations();
    },
    computed:{
        filteredLocations() {
            return this.deliveryLocations.filter(l => l.name?.toLowerCase().includes(this.queryLocation?.toLowerCase()))
        }
    },
    methods:{
        async fetchOrderNos(){
            try {

                this.loading1 = true;
                const query = '?locationStatus[eq]=0';
                const response1 = await deptOrdersItems(query);
                this.itemsWithoutLocation = response1.data;
                this.orgData = response1.data;                

                this.orders = [];
                const response = await orderNosList();
                
                this.orders = response.data;
                this.uniqueOrderNos = [
                    ...new Map(this.orgData.map(e => [e.deptPo, e])).values()
                ];
                
                const filtered = this.orders.filter(e=>
                    this.uniqueOrderNos.some(i => i.deptPo==e.poNo)
                );

                this.loading1 = false;
                
                this.orders = filtered;
            } catch (error) {
                this.showErrorToast(error.response.data);
            }
        },
        getLocations(){
            getDeliveryLocations().then((res)=> 
                {
                    this.deliveryLocations = res.data                                        
                }
                ).catch((error)=>this.showErrorToast(error.response.data));
        },
        filterItems(){
            
            if(this.selectedOrder==null){
                this.itemsWithoutLocation = this.orgData;
                return;
            }

            const order = this.orders.filter(o => o.id==this.selectedOrder);            
            this.poId = order[0].id;
            const filtered = this.orgData.filter((i)=>{
                return i.deptPo == order[0].poNo;
            });
            this.itemsWithoutLocation = filtered;

        },
        checkSingleLocation(){

        },
        findLocation(){
            this.selectedLocation = this.deliveryLocations.find(l => l.id==this.singleDeliveryLocation );
        },
        async handleSaveSingleLocation(){

            // constructing location data to store item wise locations like multi location
            let location = [];
            this.itemsWithoutLocation.forEach(e => {
                location.push({
                    itemId:e.id,
                    quantity:e.quantity,
                    location:this.singleDeliveryLocation,
                })
            });

            this.loading1 = true;
            try {
                const response = await createDeptPOItemLocation({locations:location, totalQuantity:0, locationType:1, poId:this.poId});
                this.showSuccessToast(response.data);
                this.locationDelivery = null;
                this.queryLocation = null;
                this.loading1 = false;   
                this.fetchOrderNos();             
            } catch (error) {
                this.showErrorToast(error);
                this.loading1 = false;
            }

        },
        async handleSaveMultiLocation(){
            this.loading1 = true;
            if(this.deliveryLocation.length==0){
                this.loading1 = false;
                return this.showErrorToast({message:'Location cannot be empty!'});
            }
            let checkQty=0;
            
            this.deliveryLocation.forEach(element => {
                checkQty += element.quantity;                
                if(element.location==null || element.location==""){
                    checkQty = 0;
                    this.loading1 = false;
                    return this.showErrorToast({message:'Location cannot be empty!'});
                }
            });
            if(checkQty!=this.poItem.quantity){
                this.loading1 = false;
                return this.showErrorToast({message:'Total quantity should be equal to item quantity!'});
            }

            try {
                const response = await createDeptPOItemLocation({locations:this.deliveryLocation, totalQuantity:0, locationType:this.locationDelivery, poId:this.poId});
                this.showSuccessToast(response.data);
                this.locationDialog = false;
                this.loading1 = false;
                this.fetchOrderNos();
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.locationDialog = false;
                this.loading1 = false; 
            }
            
        },
        bindData(data){
            this.deliveryLocation = data;
        },
        showMultiLocationDialog(item){ 
            this.poItem = item;
            this.locationDialog = true;         
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 4000 });
        },
        formatCurrency(value) {
            if (value == null || isNaN(value)) return '-';
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        formatNumber(value) {
                return value.toLocaleString('en-IN', {maximumFractionDigits:4, minimumFractionDigits:2});
        },
    }

}
</script>

<style scoped>

select,
input[type="text"] {
  border: 1px solid #d1d5db;      /* light gray border */
  border-radius: 0.5rem;          /* rounded corners */
  padding: 0.5rem 0.75rem;
  background-color: #ffffff;      /* white background */
  color: #374151;                 /* dark gray text */
  font-size: 0.95rem;
  width: 100%;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  box-sizing: border-box;
}

/* Hover effect */
select:hover,
input[type="text"]:hover {
  border-color: #14b8a6;          /* medium gray */
}

/* Focus effect */
select:focus,
input[type="text"]:focus {
  outline: none;
  border-color: #14b8a6;          /* indigo (PrimeVue primary color) */
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
}

/* Disabled state */
select:disabled,
input[type="text"]:disabled {
  background-color: #f9fafb;
  border-color: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}

</style>